import { CropCorners, SectionLabel } from "../Marks";
import { Reveal } from "../Reveal";

const BASE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_production-made-real/artifacts";

const SLOTS = [
  {
    src: `${BASE}/tb2h8o1v_ProjectPhoto1.png`,
    alt: "Stage 01 — Original art: customer-provided photo of a three wise monkeys statue.",
    testid: "work-slot-1",
  },
  {
    src: `${BASE}/kfq6csq7_ProjectPhoto2.png`,
    alt: "Stage 02 — Production art: cleaned, prepared, print-ready high-resolution vector illustration of the three monkeys.",
    testid: "work-slot-2",
  },
  {
    src: `${BASE}/c9v0brz0_ProjectPhoto3.png`,
    alt: "Stage 03 — Finished product: the artwork printed on a black No Glyph Studios t-shirt.",
    testid: "work-slot-3",
  },
];

export const Work = () => (
  <section
    id="our-work"
    data-testid="section-our-work"
    className="relative border-b border-[#2a2a2a] bg-[#0a0a0a] px-5 py-20 sm:px-8 sm:py-28"
  >
    <div className="mx-auto max-w-[1600px]">
      <div className="flex flex-wrap items-end justify-between gap-6 border-b border-[#222] pb-8">
        <SectionLabel index="02">OUR WORK</SectionLabel>
        <p className="font-mono-tech text-[0.65rem] uppercase tracking-[0.22em] text-neutral-400">
          ORIGINAL ART → PRODUCTION ART → FINISHED PRODUCT
        </p>
      </div>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {SLOTS.map((s, i) => (
          <Reveal key={s.testid} delay={i * 0.09}>
            <figure
              data-testid={s.testid}
              className="group relative overflow-hidden border border-[#242424] transition-colors duration-500 hover:border-[#0055ff]"
            >
              <img
                src={s.src}
                alt={s.alt}
                loading={i === 0 ? "eager" : "lazy"}
                decoding="async"
                className="block aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
              />
              <CropCorners color="#5a5a5a" />
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
